<template>
  <div class="right-card">
    <template v-if="!noHeader">
      <p class="title">预估定向</p>
      <div class="data-part">
        <div class="data-item mr" v-show="form.mode == '控成本投放'">
          <p class="subtitle">
            广告展示数
            <el-popover placement="top" trigger="hover" width="230">
              <p style="font-size: 12px; line-height: 2">
                根据头条、抖音、西瓜、抖音火山版、穿山甲等广告位展示量计算得出，大于1小时，默认展示最小值
              </p>
              <i class="el-icon-question" slot="reference"></i>
            </el-popover>
          </p>
          <p class="number">
            {{ numberFormat(adShowNum).value }}
            <span class="unit">{{ numberFormat(adShowNum).unit }}</span>
          </p>
        </div>
        <div class="data-item">
          <p class="subtitle">
            用户覆盖数
            <el-popover placement="top" trigger="hover" width="230">
              <p style="font-size: 12px; line-height: 2">
                根据头条、抖音、西瓜、抖音火山版、穿山甲等广告位的日活用户计算得出，大于1万时，默认展示最小值
              </p>
              <i class="el-icon-question" slot="reference"></i>
            </el-popover>
          </p>
          <p class="number">
            {{ numberFormat(userNum).value }}
            <span class="unit">{{ numberFormat(userNum).unit }}</span>
          </p>
        </div>
      </div>
    </template>
    <div class="info" v-show="form.directional == '自定义人群'">
      <p class="title-second">已选定信息</p>
      <div class="audience-list">
        <div class="audience-item">
          <span class="audience-title">地域</span>
          {{
            form.audience.regionArr.length == 0
              ? "不限"
              : form.audience.regionArr.join("、")
          }}
        </div>
        <div class="audience-item">
          <span class="audience-title">性别</span>
          {{ form.audience.sex }}
        </div>
        <div class="audience-item">
          <span class="audience-title">年龄</span>
          {{
            form.audience.age.length == 0
              ? "不限"
              : form.audience.age.join("，")
          }}
        </div>
        <template v-if="isStandard">
          <div class="audience-item" v-if="form.audience.interest != '自定义'">
            <span class="audience-title">兴趣行为</span>
            {{ form.audience.interest }}
          </div>
          <template v-else>
            <div
              class="audience-item"
              v-show="form.audience.behavioralInterest.scene.length > 0"
            >
              <span class="audience-title">行为场景</span>
              {{ form.audience.behavioralInterest.scene.join("，") }}
            </div>
            <div class="audience-item">
              <span class="audience-title">行为天数</span>
              {{ form.audience.behavioralInterest.day }}
            </div>
            <div
              class="audience-item"
              v-show="form.audience.behavioralInterest.behaviorArr.length > 0"
            >
              <span class="audience-title">行为类目词</span>
              {{ form.audience.behavioralInterest.behaviorArr.join("，") }}
            </div>
            <div
              class="audience-item"
              v-show="form.audience.behavioralInterest.interestArr.length > 0"
            >
              <span class="audience-title">兴趣类目词</span>
              {{ form.audience.behavioralInterest.interestArr.join("，") }}
            </div>
          </template>
        </template>
        <div class="audience-item" v-if="!isSearch">
          <span class="audience-title">抖音达人</span>
          {{ form.audience.talent }}
        </div>
        <div v-if="showOther">
          <div class="audience-item">
            <span class="audience-title">网络</span>
            {{
              form.audience.network.length == 0
                ? "不限"
                : form.audience.network.join("，")
            }}
          </div>
          <div class="audience-item">
            <span class="audience-title">平台</span>
            {{ form.audience.platform }}
          </div>
          <div class="audience-item" v-if="isStandard">
            <span class="audience-title">更多人群</span>
            {{ form.audience.morePopulation }}
          </div>
          <div class="audience-item">
            <span class="audience-title">智能放量</span>
            <span v-if="form.audience.autoExtend != '开启'">{{
              form.audience.autoExtend
            }}</span>
            <span v-else>{{
              form.audience.extendArr.length == 0
                ? "不启用"
                : form.audience.extendArr.join("，")
            }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    form: Object,
    noHeader: Boolean,
    isSearch: Boolean,
    showOther: Boolean,
    isStandard: Boolean,
  },
  data() {
    return {
      adShowNum: 15190000000,
      userNum: 2030000000,
    };
  },
  methods: {
    numberFormat(value) {
      let param = {};
      let k = 10000;
      let sizes = ["", "万", "亿", "万亿"];
      let i;
      if (value < k) {
        param.value = value;
        param.unit = "";
      } else {
        i = Math.floor(Math.log(value) / Math.log(k));
        param.value = (value / Math.pow(k, i)).toFixed(2);
        param.unit = sizes[i];
      }
      return param;
    },
  },
};
</script>

<style lang="less" scoped>
.right-card {
  float: right;
  position: absolute;
  right: 0;
  top: 0;
  padding: 24px;
  width: 310px;
  border: 1px solid #e3e3e4;
  border-radius: 4px;
  z-index: 99;
  .title {
    line-height: 22px;
    font-weight: 600;
    font-size: 16px;
    color: #111;
  }
  .data-part {
    margin-top: 16px;
    margin-bottom: 20px;
    .data-item {
      display: inline-block;
      width: 124px;
      &.mr {
        margin-right: 12px;
      }
      .subtitle {
        line-height: 17px;
        font-size: 12px;
        color: #111;
        .el-icon-question {
          margin-left: 3px;
          color: #d3d3d3;
          font-size: 16px;
          vertical-align: middle;
          cursor: pointer;
        }
      }
      .number {
        margin-top: 4px;
        line-height: 33px;
        font-family: OPPOSans-H;
        font-weight: 800;
        font-size: 24px;
        color: #111;
        .unit {
          // margin-left: 4px;
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          color: #111;
        }
      }
    }
  }
  .info {
    .title-second {
      line-height: 20px;
      font-size: 14px;
      color: #333;
    }
    .audience-list {
      overflow-y: scroll;
      margin-top: 16px;
      height: 104px;
      &::-webkit-scrollbar {
        width: 4px;
        background-color: #f5f5f5;
      }

      &::-webkit-scrollbar-track {
        box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
        border-radius: 10px;
        background-color: #f5f5f5;
      }

      &::-webkit-scrollbar-thumb {
        border-radius: 10px;
        box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
        background-color: #c8c8c8;
      }
      .audience-item {
        margin-bottom: 12px;
        line-height: 17px;
        font-size: 12px;
        color: #666;
        .audience-title {
          margin-right: 12px;
          color: #333;
        }
      }
    }
  }
}
</style>